import { useTranslation } from 'react-i18next';
import { Button } from '../../../../common/components/ui/button';
import { abortUserInputForCart } from '../../actions/cartActions';
import { CartDialogDeliveryCalendar } from './CartDialogDeliveryCalendar';

function handleAbort() {
  abortUserInputForCart();
}

export function CartDialogChooseDeliveryDate() {
  const { t } = useTranslation();

  return (
    <CartDialogDeliveryCalendar title={t('Wählen Sie ein Datum aus')}>
      <Button
        variant={'primaryOutline'}
        className={'w-full desktop:w-fit'}
        onClick={handleAbort}
        data-testid={'cart-cancel-button'}
      >
        {t('Abbrechen')}
      </Button>
    </CartDialogDeliveryCalendar>
  );
}
